<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Expired Items",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Expired Items",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Expired Items",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "pharmacyItem.drug_namex",
          sortable: true,
          label: "NAME",
        },
        {
          key: "batchNumber",
          sortable: true,
          label: "BATCH",
        },
        {
          key: "removed",
          sortable: true,
          label: " REMOVED",
        },
        {
          key: "days_field",
          sortable: true,
          label: "EXPIRED",
        },
        {
          key: "expiryDate",
          sortable: true,
          label: "EXPIRY DATE",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      remove: {
        name: "",
        stock: "",
        id: "",
        qty: "",
        product: "",
        status: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("pharmacy", ["ExpiredItems", "DispenseState"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ExpiredItems ? this.ExpiredItems.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ExpiredItems ? this.ExpiredItems.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      fetchExpiredItems: "pharmacy/fetchExpired",
      RemoveDrug: "pharmacy/removeDrug",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    showExpiredModal(data) {
      this.remove.name = data.item.pharmacyItem.drug_name;
      this.remove.product = data.item.pharmacyItem.id;
      this.remove.id = data.item.id;
      this.remove.status = 1;
    },
    resetModal() {
      this.remove.name = "";
      this.remove.id = "";
      this.remove.qty = "";
      this.remove.stock = "";
      this.remove.product = "";
    },
    resetqty() {
      this.remove.qty = "";
    },
    removeexp(modalId) {
      if ((this.remove.status == 1 && this.remove.qty != "") || this.remove.status == 2) {
        this.modal_id = modalId;
        this.RemoveDrug(this.remove);
      }
    },
    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.fetchExpiredItems();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-8">
                <h5 class="text-primary">Items that expired</h5>
              </div>
              <div class="col-4">
                <div>
                  <router-link
                    v-if="user_permissions.view_stock"
                    :to="{
                      name: 'Stock',
                    }"
                  >
                    <b-button class="float-end" variant="primary"
                      ><i class="fa fa-undo"></i> Stock</b-button
                    >
                  </router-link>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="ExpiredItems ? ExpiredItems : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(days_field)="data">
                  {{ data.item.days * -1 }} days ago
                </template>
                <template #cell(actions)="data">
                  <b-button
                    size="sm"
                    variant="warning"
                    v-b-modal.expired-modal
                    @click="showExpiredModal(data)"
                    v-if="!data.item.removed && user_permissions.remove_expired_staock"
                    ><i class="fa fa-minus"></i> Remove</b-button
                  >
                  <b-button
                    v-else-if="
                      !data.item.removed && user_permissions.remove_expired_staock == 0
                    "
                    disabled
                    size="sm"
                    variant="warning"
                    v-b-modal.expired-modal
                    ><i class="fa fa-minus"></i> Remove</b-button
                  >
                </template>
              </b-table>
              <div style="text-align: center;">
                <h3 v-if="!ExpiredItems" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal mark as expired starts -->
    <b-modal id="expired-modal" hide-footer @hidden="resetModal">
      <template #modal-title>
        <h4 class="text-warning">Remove this Item from Stock</h4></template
      >
      <div class="form-group">
        <label for="">Stock Status</label>
        <select class="form-control" v-model="remove.status" @change="resetqty()">
          <option value="1" selected>Was Still in Stock</option>
          <option value="2">Was Out of Stock</option>
        </select>
      </div>
      <div class="form-group mb-3" v-if="this.remove.status == 1">
        <label>Quantity Removed</label>
        <div class="input-group">
          <input
            type="number"
            class="form-control"
            v-model="remove.qty"
            placeholder="Quantity removed"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('expired-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-warning" @click="removeexp('expired-modal')">
          <i class="fa fa-minus"></i> Confirm
          <b-spinner
            v-if="DispenseState"
            variant="light"
            small
            label="Submiting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>
